import {ref} from "vue";
import {useMutation, useQuery, useQueryClient} from "@tanstack/vue-query";
import axios from "axios";
import {errorToast, successToast} from "@/composables/useToasts";
import useApprovalFlow from "@/composables/approval-center/useApprovalFlow";

const showModal = ref(false);
const showLoadingModal = ref(false);

const reset = () => {
  showModal.value = false;
  showLoadingModal.value = false;
};

const getBusinessBible = () => useQuery({
  queryKey: ['business-bible'],
  queryFn: async () => {
    const { data } = await axios.get(`/ajax/v2/seo-agent-settings/business-bible`);

    return data.data;
  }
});

const reviseBusinessBible = () => {
  const queryClient = useQueryClient();
  const {revisionErrors} = useApprovalFlow();

  return useMutation({
    mutationFn: async (data) => {
      showLoadingModal.value = true;
      revisionErrors.value = undefined;

      const {feedback, individualFeedbacks = null} = data;

      await axios.post('/ajax/v2/seo-agent-settings/revise-business-bible', {
        feedback,
        individual_feedbacks: individualFeedbacks,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['business-bible']});

      successToast("AI Business Profile revised successfully.");
    },
    onError: (error) => {
      let errorMessage = error.response?.data?.message || 'Something went wrong revising your AI Business Profile';

      if (error.response?.data?.errors) {
        revisionErrors.value = error.response?.data?.errors;
      }

      errorToast(errorMessage);
    },
  });
};

export {
  showModal,
  showLoadingModal,
  reset,
  getBusinessBible,
  reviseBusinessBible,
};
